<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Tipo de Transporte:"
    id="selectEvento"
    placeholder="Selecione o Tipo de Transpote"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isRequired="true"
  ></NxSelectReduced>
</template>
<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

import KmValueRepository from '@/shared/http/repositories/configurations/kmvalue.js'

export default {
  name: 'NxSelectTipoTransporte',
  mixins: [useReactiveModelMixin('value')],
  data () {
    return {
      listOptions: []
    }
  },
  created () {
    this.onLoadAllTipoTransporte()
  },
  methods: {
    async onLoadAllTipoTransporte () {
      try {
        const response = await KmValueRepository.GetAllActive()

        if (!response || !response.data || !response.data.content) return

        this.listOptions = response.data.content.map((content) => ({
          value: content.id,
          text: content.tipoTransporte
        }))
      } catch (error) {
        toast.error(
          'Não foi possível carregar a lista de tipos de transporte',
          'Erro'
        )
        console.error(error)
      } finally {
        loading.close()
      }
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoTransporte.vue